import React from 'react';

import { Container } from './styles';

function Card(props) {
  return <Container>{props.children}</Container>;
}

export default Card;
